'use client'

import { Skeleton } from '@/components/ui/skeleton'

// Suspense fallback for lazy-loaded routed pages — shown inside Layout
// while Navbar/Footer (rendered outside the Suspense boundary) are already
// visible, so the chrome never disappears during a route's chunk download.
export function PageSkeleton() {
  return (
    <div className="mx-auto flex w-full max-w-3xl flex-col gap-3 px-3 py-6 sm:px-0">
      <Skeleton className="h-8 w-2/3 bg-white/8" />
      <Skeleton className="h-4 w-1/2 bg-white/8" />
      <div className="mt-4 flex flex-col gap-2.5">
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={i} className="h-20 w-full rounded-xl bg-white/8" />
        ))}
      </div>
    </div>
  )
}
